import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import Notes from '../../components/Notes';
import { selectNotes } from '../../store/selectors/faqsNotesDocuments';
import { fetchFaqsNotesDocuments, saveFaqsNotesDocuments,updateFaqsNotesDocuments,deleteFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setSearch, clearSearch } from '../../store/actions/search'
import { fetchSuiteCounts } from '../../store/actions/suites';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import Loader from '../../components/Loader';

class SuiteNotes extends Component {
  componentDidMount(){
    this.props.clearSearch()
    this.props.onFetchFaqsNotesDocuments(this.props.suite.id)
  }


  onSaveNote = async (note) => {
    const {  onSaveFaqsNotesDocuments,onUpdateFaqsNotesDocuments  } = this.props;
    let utcTime=''
    if(note.appointment){
 
    let date = new Date(note.appointment.date);
    let time = new Date(note.appointment.time)
    let hours = time.getHours();
    let minutes =time.getMinutes();
    date.setHours(hours);
    date.setMinutes(minutes)
 
    //  utcTime = date.toUTCString()
    utcTime = date
    }

    if(note.id){
      let data = {
        ItemId: this.props.suite.id,
        "id": note.id,
        Name: 'NOTES',
        ItemType: 'Suite',
        "data": JSON.stringify(note).toString(),
        "UserId": this.props.user.id,
        'visibilityType':note.visibilityType,
        noteVisibleToHomeownerOccupantRealtor:note.noteVisibleToHomeownerOccupantRealtor,
      }
      if(note.appointment){
        data.ReminderDate = utcTime
      }
      onUpdateFaqsNotesDocuments(data)

    }else{
      note = { ...note,'author':{
        "id": this.props.user.id,
        "firstName": this.props.user.firstname,
        "lastName": this.props.user.lastname
      },'createdAt': new Date()}
      let data = {
        ItemId: this.props.suite.id,
        Name: 'NOTES',
        Type: 'NOTES',
        ItemType: 'Suite',
        Data: JSON.stringify(note).toString(),
        UserId: this.props.user.id,
        'visibilityType':note.visibilityType,
        noteVisibleToHomeownerOccupantRealtor:note.noteVisibleToHomeownerOccupantRealtor,
       
      }
      if(note.appointment){
        data.ReminderDate = utcTime
      }
      await onSaveFaqsNotesDocuments(data)
      this.props.onFetchSuiteCounts(this.props.suite.id,this.props.user.roles[0].role.name);  

    }
  }

  onDeleteFaqsNotesDocuments = async (notes) => {
    const { onDeleteFaqsNotesDocuments } = this.props;
    notes.Type = 'NOTES';
    notes.ItemType = 'Suite';

    await onDeleteFaqsNotesDocuments(notes)
    this.props.onFetchSuiteCounts(this.props.suite.id,this.props.user.roles[0].role.name);  
  }

  render() {
    const { notes, suite,onDeleteFaqsNotesDocuments,setSearch, loader  } = this.props;
    return (
      loader ? <Loader /> :
      <Notes
        from={'suites'}
        breadcrumb={suite.number}
        notes={notes}
        onSaveNote={this.onSaveNote}
        onDeleteNote={ notes => this.onDeleteFaqsNotesDocuments(notes)}
        onSearch={e => setSearch({ notes: e.target.value.trim() })}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  notes: selectNotes(state),
  user: selectAuthenticatedUser(state),
  loader: selectPRLoader(state),

});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchFaqsNotesDocuments: fetchFaqsNotesDocuments,
  onSaveFaqsNotesDocuments: saveFaqsNotesDocuments,
  onUpdateFaqsNotesDocuments:updateFaqsNotesDocuments,
  onDeleteFaqsNotesDocuments:deleteFaqsNotesDocuments,
  setSearch,
  clearSearch,
  onFetchSuiteCounts: fetchSuiteCounts
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SuiteNotes);
